import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";
import { SCHOOL_INSTALLMENTS_PDC } from "../../apiRoutes";

export interface PdcData {
  _id: string;
  pdcId: string;
  installmentId: string;
  pdcNumber: string;
  pdcAmount: number;
  pdcDate: string;
  pdcStatus: string;
  pdcAmountReceived: number;
  pdcClearedDate?: string;
  pdcRemarks: string;
  pdcYear: string;
  createdAt: string;
  updatedAt: string;
  pdcCreatedByData:any;
  remarksHistory: { pdcRemarks: string; createdAt: string,createdByName:string,createdBy:string }[];
}

export interface PdcResponse {
  data: PdcData[];
  message: string;
  success: boolean;
}

export const useGetPdcByInstallmentIdQuery = (
  installmentId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["pdc", installmentId],
    queryFn: async (): Promise<PdcResponse> => {
      const response = await axiosAuth.get(`${SCHOOL_INSTALLMENTS_PDC}${installmentId}/`);
      return response.data;
    },
    enabled: !!installmentId && (options?.enabled ?? true),
  });
};
